import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";

import { PasswordSettingsComponent } from "./password-settings/password-settings.component";
import { SecurityKeysComponent } from "./security-keys.component";
import { SecurityComponent } from "./security.component";
import { WebDeviceManagementComponent } from "./web-device-management.component";
import { WebTwoFactorSetupComponent } from "./web-two-factor-setup.component";

const routes: Routes = [
  {
    path: "",
    component: SecurityComponent,
    data: { titleId: "security" },
    children: [
      { path: "", pathMatch: "full", redirectTo: "two-factor" },
      {
        path: "password",
        component: PasswordSettingsComponent,
        data: { titleId: "masterPassword" },
      },
      {
        path: "two-factor",
        component: WebTwoFactorSetupComponent,
        data: { titleId: "twoStepLogin" },
      },
      {
        path: "security-keys",
        component: SecurityKeysComponent,
        data: { titleId: "keys" },
      },
      {
        path: "device-management",
        component: WebDeviceManagementComponent,
        data: { titleId: "devices" },
      },
    ],
  },
];

@NgModule({
  imports: [
    RouterModule.forChild(routes),
    PasswordSettingsComponent,
    SecurityComponent,
    SecurityKeysComponent,
    WebDeviceManagementComponent,
    WebTwoFactorSetupComponent,
  ],
  exports: [RouterModule],
})
export class SecurityRoutingModule {}
